export class LineSliderResults{

  minAvailableStock: number;

  maxAvailableStock: number;
  loading: boolean = true;
}
